import { TransportManagementSearchCriteria } from '../models';

export class TransportManagementLoadFetch {
  public static readonly type = '[TransportManagementLoad] Fetch';
  constructor(public payload: TransportManagementSearchCriteria) {}
}

export class TransportManagementLoadInitialState {
  public static readonly type = '[TransportManagementLoad] Set Initial State';
}
